import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, InputSignal, Output } from '@angular/core';

@Component({
  selector:        'app-checkbox',
  imports: [
    NgClass
],
  templateUrl:     './checkbox.component.html',
  styleUrl:        './checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent {

  @Input() checkboxModel: CheckboxModel[];

  disabled: InputSignal<boolean> = input(false);

  @Output()
  public checkChange: EventEmitter<CheckboxModel> = new EventEmitter();

  @Output()
  public clickLabel: EventEmitter<CheckboxModel> = new EventEmitter();
}

export interface CheckboxModel {
  checked: boolean;
  label: string;
  key: string;
  clickableLabelText?: string;
}
